// Plain-English labels for casual fans (no React, so share.js canvas cards can use it too).
//
// playText: a prop the way fans say it. A half-point line is book jargon — "Pass TDs O1.5" is
// really "2+ passing TDs", "Rec Yds o48.5" is "49+ receiving yds" (identical: over 48.5 = 49 or
// more). Whole-number lines can push, so they keep "Over 5 catches". Unders read "48 or fewer…".
//
// teamNick: "Bills" instead of "BUF" — people know the team, not always the city abbreviation.

const NOUN = {
  receptions: 'catches', 'Receptions': 'catches',
  rec_yards: 'receiving yds', 'Rec Yds': 'receiving yds',
  rush_yards: 'rushing yds', 'Rush Yds': 'rushing yds',
  pass_yards: 'passing yds', 'Pass Yds': 'passing yds',
  pass_tds: 'passing TDs', 'Pass TDs': 'passing TDs',
}
const isTdMkt = m => m === 'anytime_td' || m === 'Anytime TD' || m === 'ATD'

export function playText(market, line, side = 'over') {
  if (isTdMkt(market)) return 'Anytime TD'
  const noun = NOUN[market]
  const n = Number(line)
  if (line == null || line === '' || Number.isNaN(n)) return noun ? noun[0].toUpperCase() + noun.slice(1) : (market || '')
  if (!noun) return `${market} ${side === 'under' ? 'under' : 'over'} ${line}`
  const half = Math.abs(n * 2 - Math.round(n * 2)) < 1e-9 && Math.round(n * 2) % 2 !== 0
  if (side === 'under') return half ? `${Math.floor(n)} or fewer ${noun}` : `Under ${n} ${noun}`
  return half ? `${Math.ceil(n)}+ ${noun}` : `Over ${n} ${noun}`
}

export const TEAM_NICK = {
  ARI: 'Cardinals', ATL: 'Falcons', BAL: 'Ravens', BUF: 'Bills', CAR: 'Panthers', CHI: 'Bears',
  CIN: 'Bengals', CLE: 'Browns', DAL: 'Cowboys', DEN: 'Broncos', DET: 'Lions', GB: 'Packers',
  HOU: 'Texans', IND: 'Colts', JAX: 'Jaguars', KC: 'Chiefs', LA: 'Rams', LAR: 'Rams', LAC: 'Chargers',
  LV: 'Raiders', MIA: 'Dolphins', MIN: 'Vikings', NE: 'Patriots', NO: 'Saints', NYG: 'Giants',
  NYJ: 'Jets', PHI: 'Eagles', PIT: 'Steelers', SEA: 'Seahawks', SF: '49ers', TB: 'Buccaneers',
  TEN: 'Titans', WAS: 'Commanders', WSH: 'Commanders',
}
export const teamNick = abbr => TEAM_NICK[(abbr || '').toUpperCase()] || abbr || ''

// Depth-chart roles in plain words ("WR1" -> "top WR"). Unknown roles pass through.
export const ROLE_TEXT = { WR1: 'top WR', WR2: '#2 WR', WR3: '#3 WR', WR_OTHER: 'other WR', TE1: 'top TE', TE2: '#2 TE',
  TE_OTHER: 'other TE', RB1: 'lead RB', RB2: 'backup RB', QB: 'QB (runs)' }
export const roleText = (role, fallback = '') => ROLE_TEXT[role] || fallback || role || ''

// Server-written sentences ("LV #4 softest to WRs", "LV #7 vs the run") use team codes; swap a
// code for the nickname only where it's clearly a team (followed by #, a team verb, or "defense").
const _TEAM_RE = new RegExp(`\\b(${Object.keys(TEAM_NICK).join('|')})\\b(?=\\s+(#|plays?\\b|defense\\b|allows?\\b|gives?\\b|is\\b|ranks?\\b|soft|vs\\b))`, 'g')
export const nickify = (text) => (typeof text === 'string' ? text.replace(_TEAM_RE, (m) => teamNick(m)) : text)
